import { ArrowRight } from '@phosphor-icons/react';
import './HowItWorks.css';

const steps = [
  {
    number: '01',
    title: 'Kennismaking',
    description: 'We bespreken uw personeelsbehoeften en bedrijfscultuur om een perfect match te garanderen.',
  },
  {
    number: '02',
    title: 'Selectie & screening',
    description: 'We zoeken en screenen kandidaten op vakbekwaamheid, certificeringen en motivatie.',
  },
  {
    number: '03',
    title: 'Plaatsing',
    description: 'De gekozen kandidaat start bij u. Wij regelen alle administratie en contracten.',
  },
  {
    number: '04',
    title: 'Nazorg & support',
    description: 'We blijven betrokken met regelmatige evaluaties en staan altijd klaar voor vragen.',
  },
];

const HowItWorks = () => {
  return (
    <section className="how-it-works" id="hoe-het-werkt">
      <div className="hiw-container">
        <div className="hiw-header">
          <span className="hiw-tag">Hoe het werkt</span>
          <h2 className="hiw-title">Uw personeel in vier stappen</h2>
          <p className="hiw-subtitle">
            Van eerste contact tot succesvolle plaatsing — wij begeleiden het hele proces.
          </p>
        </div>

        <ol className="hiw-steps">
          {steps.map((step) => (
            <li key={step.number} className="hiw-step">
              <span className="hiw-step-number" aria-hidden="true">{step.number}</span>
              <div className="hiw-step-body">
                <h3 className="hiw-step-title">{step.title}</h3>
                <p className="hiw-step-description">{step.description}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="hiw-cta">
          <a href="#contact" className="hiw-cta-button">
            Start samenwerking
            <ArrowRight size={17} weight="bold" aria-hidden="true" />
          </a>
          <p className="hiw-cta-note">Gratis kennismakingsgesprek</p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
